"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConferenceLeads() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const speakers = [{
    id: 1,
    name: "Dr. Elena Martinez",
    affiliation: "Professor of Computer Science\nStanford University"
  }, {
    id: 2,
    name: "Prof. James Chen",
    affiliation: "Director of AI Research\nMIT Media Lab"
  }, {
    id: 3,
    name: "Dr. Sarah Williams",
    affiliation: "Head of Innovation\nCalifornia Institute of Technology"
  }];
  return;
}